<template>
    <div class="content-item" :class="itemClass">
        <img v-if="profilePicSrc" :src="profilePicSrc" alt="profile picture" class="profile-pic" :class="picClass" />
        <div class="text-wrapper">
            <div class="header" :class="headerClass">
                @{{ item.author }} • {{ timeElapsed }}
            </div>
            <div class="content" :class="contentClass">
                {{ item.content }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContentItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        timeElapsed: {
            type: String,
            required: true
        },
        type: {
            type: String,
            default: 'post' // post or reply
        }
    },
    computed: {
        headerClass() {
            return `header-${this.type}`;
        },
        contentClass() {
            return `content-${this.type}`;
        },
        itemClass() {
            return `item-${this.type}`;
        },
        picClass() {
            return `pic-${this.type}`;
        },
        profilePicSrc() {
            if (this.item.profile_pic) {
                return `data:image/*;base64,${this.item.profile_pic}`;
            }
            return '';
        }
    }
}
</script>

<style lang="scss" scoped>
.content-item {
    display: flex;
    align-items: flex-start;
}

.profile-pic {
    border-radius: 50%;
    margin-right: 10px;
}

.pic-post {
    width: 32px;
    height: 32px;
}

.pic-reply {
    width: 32px;
    height: 32px;
}

.text-wrapper {
    flex: 1;
}

.header-post {
    display: flex;
    margin-bottom: 15px;
}

.header-reply {
    color: #ddd;
    font-size: 14px;
    margin-bottom: 8px;
}

.content-reply {
    color: #ddd;
    font-size: 14px;
}
</style>
